import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/app/Layout";
import ProtectedRoute from "@/components/app/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Browse from "@/pages/Browse";
import ServiceDetail from "@/pages/ServiceDetail";
import Booking from "@/pages/Booking";
import Payment from "@/pages/Payment";
import MyBookings from "@/pages/MyBookings";
import Account from "@/pages/Account";
import VendorInsights from "@/pages/VendorInsights";
import ProviderDashboard from "@/pages/ProviderDashboard";
import ProviderListings from "@/pages/ProviderListings";
import ProviderBookings from "@/pages/ProviderBookings";
import ProviderKyc from "@/pages/ProviderKyc";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminFeedback from "@/pages/AdminFeedback";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminSatisfaction from "@/pages/AdminSatisfaction";
import AdminRequests from "@/pages/AdminRequests";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/services/:id" element={<ServiceDetail />} />
              <Route path="/insights/:vendor" element={<VendorInsights />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              <Route path="/booking/:serviceId" element={
                <ProtectedRoute roles={["customer"]}><Booking /></ProtectedRoute>
              } />
              <Route path="/payment/:bookingId" element={
                <ProtectedRoute roles={["customer"]}><Payment /></ProtectedRoute>
              } />
              <Route path="/bookings" element={
                <ProtectedRoute roles={["customer"]}><MyBookings /></ProtectedRoute>
              } />
              <Route path="/account" element={
                <ProtectedRoute roles={["customer","provider","admin"]}><Account /></ProtectedRoute>
              } />

              <Route path="/provider" element={
                <ProtectedRoute roles={["provider"]}><ProviderDashboard /></ProtectedRoute>
              } />
              <Route path="/provider/listings" element={
                <ProtectedRoute roles={["provider"]}><ProviderListings /></ProtectedRoute>
              } />
              <Route path="/provider/bookings" element={
                <ProtectedRoute roles={["provider"]}><ProviderBookings /></ProtectedRoute>
              } />
              <Route path="/provider/kyc" element={
                <ProtectedRoute roles={["provider"]}><ProviderKyc /></ProtectedRoute>
              } />

              <Route path="/admin" element={
                <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
              } />
              <Route path="/admin/feedback" element={
                <ProtectedRoute roles={["admin"]}><AdminFeedback /></ProtectedRoute>
              } />
              <Route path="/admin/analytics" element={
                <ProtectedRoute roles={["admin"]}><AdminAnalytics /></ProtectedRoute>
              } />
              <Route path="/admin/satisfaction" element={
                <ProtectedRoute roles={["admin"]}><AdminSatisfaction /></ProtectedRoute>
              } />
              <Route path="/admin/requests" element={
                <ProtectedRoute roles={["admin"]}><AdminRequests /></ProtectedRoute>
              } />

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
